/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var E;!function(E){E[E.NEW_STEP=0]="NEW_STEP",E[E.ACCUMULATE_STEPS=1]="ACCUMULATE_STEPS"}(E||(E={}));export{E as AccumulationBehavior};
